<app-side-menu>
  <div class="b2b-contracts-drivers-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <button class="btn-back" (click)="navigateBack()">
                <i class="fas fa-arrow-left"></i>
              </button>
              <h1 class="page-title">
                <i class="fas fa-users me-3"></i>
                Condutores do Contrato
              </h1>
              <p class="page-subtitle" *ngIf="contractNumber">
                Contrato: {{ contractNumber }} - {{ contractName }}
              </p>
            </div>
            <div>
              <app-button
                *appHasPermission="'B2BContracts.Edit'"
                text="Novo Condutor"
                color="var(--success-color)"
                height="40px"
                (buttonClick)="newDriver()">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="drivers-card">
          <div *ngIf="totalItems > 0 || isLoading || searchTerm || (drivers && drivers.length > 0); else emptyDrivers">
            <div class="table-content">
              <app-table
                [title]="'Lista de Condutores (' + totalItems + ')'"
                [data]="drivers"
                [columns]="columns"
                [loading]="isLoading"
                [clickable]="false"
                [actions]="actions"
                [showSearch]="true"
                [searchPlaceholder]="'Pesquisar nome, CPF, CNH ou matrícula...'"
                [itemsPerPage]="pageSize"
                [totalItemsFromBackend]="totalItems"
                [currentPageFromBackend]="pageNumber"
                [totalPagesFromBackend]="totalPages"
                [disablePagination]="false"
                (searchChange)="onSearchChange($event)"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)">
                <app-button
                  table-header-action
                  text="Exportar Excel"
                  color="var(--success-color)"
                  height="36px"
                  [disabled]="totalItems === 0"
                  (buttonClick)="exportExcel()">
                  <i class="fas fa-file-excel me-2"></i>
                </app-button>
              </app-table>
              <div *ngIf="!isLoading && searchTerm && drivers.length === 0" class="empty-state mt-3">
                <i class="fas fa-search"></i>
                <h3>Nenhum condutor encontrado</h3>
                <p>Nenhum resultado para "{{ searchTerm }}". Tente outro nome, CPF, CNH ou matrícula.</p>
              </div>
            </div>
          </div>

          <ng-template #emptyDrivers>
            <div class="empty-state">
              <i class="fas fa-users"></i>
              <h3>Nenhum condutor encontrado</h3>
              <p>Este contrato não possui condutores cadastrados.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
